import type { Deal } from '@paintscout/api'
import type { DashboardEstimator } from '../..'
import { removeAuth0Prefix } from '@paintscout/util'

export function updateDealOwner({ deal, newOwner }: { deal: Deal; newOwner: DashboardEstimator }): Deal {
  const now = Date.now()
  const currentOwnerId = removeAuth0Prefix(deal.owner?.id || '')
  const newOwnerId = removeAuth0Prefix(newOwner.value)

  if (!!currentOwnerId && currentOwnerId === newOwnerId) {
    return deal
  }

  const [firstName, ...lastNameParts] = newOwner.label.split(' ')
  const lastName = lastNameParts.join(' ')
  return {
    ...deal,
    owner: {
      id: newOwnerId,
      firstName,
      lastName
    },
    updated: now
  }
}
